import script from "./PromptMarkdownEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptMarkdownEditor.vue?vue&type=script&setup=true&lang=js"

import "./PromptMarkdownEditor.vue?vue&type=style&index=0&id=3fbedc2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbedc2e"]])

export default __exports__